export default {
  get_merchant_contact() {
    const { transaction, merchant_contact = null } = this.$state
    const publicKey = transaction?.merchant?.publicKey

    if (merchant_contact === null) {
      return this.$operations.getMerchantContactByPublicKey(publicKey)
        .then(res => {
          const merchant_contact = res.data
          this.$actions.setMerchantContact(merchant_contact)
          return merchant_contact
        })
    }

    return Promise.resolve(merchant_contact)
  },

  setMerchantContact(store, merchant_contact) {
    store.$mutations.SET_MERCHANT_CONTACT(merchant_contact)
  },
}
